import upperFirst from 'lodash/upperFirst';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './DueDate.module.scss';

const SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
};

const FORMATS = {
  tiny: 'longDate',
  small: 'longDate',
  medium: 'longDateTime',
};

const DueDate = React.memo(({ value, size, isDisabled, onClick, isNeutral }) => {
  const [t] = useTranslation();
  const dueRange = Math.floor((new Date(value) - new Date()) / (1000 * 60 * 60 * 24));
  let deadLineStyle = 'wrapper';
  if (!isNeutral) {
    if (dueRange < 0) {
      deadLineStyle = 'wrapperDeadLine';
    } else if (dueRange < 6) {
      deadLineStyle = 'wrapperSubDeadLine';
    }
  }

  const contentNode = (
    <span
      className={classNames(
        styles.wrapper,
        styles[deadLineStyle],
        styles[`wrapper${upperFirst(size)}`],
        onClick && styles.wrapperHoverable,
      )}
    >
      {t(`format:${FORMATS[size]}`, {
        value,
        postProcess: 'formatDate',
      })}
    </span>
  );

  return onClick ? (
    <button type="button" disabled={isDisabled} className={styles.button} onClick={onClick}>
      {contentNode}
    </button>
  ) : (
    contentNode
  );
});

DueDate.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  isNeutral: PropTypes.bool,
};

DueDate.defaultProps = {
  size: SIZES.MEDIUM,
  isDisabled: false,
  onClick: undefined,
  isNeutral: false,
};

export default DueDate;
